module.exports = __webpack_public_path__ + "img/0S6A9717.4cec59fa.jpg";